<div class="container">
  
  <app-header-dialog [iconName]="'noise_control_off'">
    {{title}}
  </app-header-dialog>

  <div class="content">

    <mat-card>
      <form class="form" name="roleForm" [formGroup]='roleForm' autocomplete="off">

        <div>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Papel</mat-label>
            <mat-select [formControl]="roleForm.controls.role">
              <mat-option *ngFor="let role of roles" [value]="role">
                {{ role.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="roleForm.controls.role.hasError('required')">
              Selecione um papel
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Colaborador (4 letras iniciais)</mat-label>
            <input matInput #memberSelected type="text" [matAutocomplete]="autoMember"
              [formControl]="roleForm.controls.member">
            <mat-autocomplete #autoMember="matAutocomplete" [displayWith]="displayMember.bind(this)">
              <mat-option *ngFor="let member of members" [value]="member">
                {{ member.name }}
                <span *ngIf="member.email"> | <small>{{ member.email }}</small></span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div>
          <button matTooltip='Ok' mat-raised-button (click)="getData()">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
        </div>

      </form>
    </mat-card>

    <div class="display-director-wrapper">
      <div *ngFor="let director of directors$ | async">
        <div class="display-director">
          <div>
            <div>
              <b>{{director.role_name}}</b>
            </div>
            <div>
              {{director.member_name}} ({{director.member_state}})
            </div>
          </div>

          <div>
            <a mat-button (click)='removeDirector(director)'>
              <mat-icon class='icon-delete'>
                delete_outline
              </mat-icon>
            </a>

          </div>
        </div>
      </div>
    </div>

  </div>


</div>